{
    "name": "ace-tablet",
    "version": "0.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port 4300",
        "dev-docker": "ng serve --host 0.0.0.0",
        "build": "ng build",
        "test": "ng test",
        "typecheck": "tsc --skipLibCheck --noEmit",
        "test:ci": "ng test --progress false --watch false",
        "test:ci-coverage": "ng test --code-coverage true --progress false --watch false",
        "lint": "ng lint --fix",
        "e2e": "ng e2e",
        "graphql": "graphql-codegen",
        "build:prod": "cross-env NODE_ENV=production ng build --configuration production",
        "build:dev": "cross-env NODE_ENV=production ng build --configuration development",
        "postinstall": "npx copyfiles -f ./node_modules/svg-country-flags/svg/*.svg ./src/assets/flags"
    },
    "private": true,
    "dependencies": {
        "@angular-eslint/schematics": "^19.1.0",
        "@angular/animations": "^19.1.0",
        "@angular/cdk": "^19.1.3",
        "@angular/common": "^19.1.0",
        "@angular/compiler": "^19.1.0",
        "@angular/core": "^19.1.0",
        "@angular/forms": "^19.1.0",
        "@angular/material": "^19.1.3",
        "@angular/platform-browser": "^19.1.0",
        "@angular/platform-browser-dynamic": "^19.1.0",
        "@angular/router": "^19.1.0",
        "@angular/service-worker": "^19.1.7",
        "@apollo/client": "^3.0.0",
        "@bugsnag/js": "^8.2.0",
        "@bugsnag/plugin-angular": "^8.3.0",
        "apollo-angular": "^8.0.2",
        "apollo-link-ws": "^1.0.20",
        "date-fns": "^4.1.0",
        "graphql": "^16",
        "pusher-js": "^8.4.0",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.1.6",
        "@angular/cli": "^19.1.6",
        "@angular/compiler-cli": "19.1.7",
        "@graphql-codegen/cli": "^5.0.4",
        "@graphql-codegen/introspection": "^4.0.3",
        "@graphql-codegen/typescript": "^4.1.3",
        "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
        "@graphql-codegen/typescript-operations": "^4.4.1",
        "@pxlwidgets/eslint-config-angular": "^17.0.1",
        "@types/jasmine": "~5.1.0",
        "cross-env": "^7.0.3",
        "eslint": "^9.20.1",
        "jasmine-core": "~5.5.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "typescript": "~5.7.2"
    }
}
